import {
  Alert,
  Divider,
  FormControl,
  FormGroup,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";

import ReactQuill from "react-quill";
import { useRef } from "react";
import { Documento } from "../../../types/processo/Documento";

type Props = {
  documento: Documento;
  isdisabled?: boolean;
  isLoading?: boolean;
  handleSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  handleCorpoChangeQuill?: (value: string) => void;
};

export function DocumentoEditarForm({
  documento,
  isdisabled = false,
  isLoading = false,
  handleSubmit,
  handleCorpoChangeQuill,
}: Props) {
  const quillRef = useRef<ReactQuill | null>(null); // Especifica que pode ser null
  const navigate = useNavigate();
  const docAssinado =
    (documento.assinaturas && documento.assinaturas.length > 0) ?? false;

  return (
    <Box mt={2} p={2}>
      <Box>
        {docAssinado && (
          <>
            <Divider
              orientation="horizontal"
              sx={{ mt: 2, mb: 2, borderColor: "primary.main" }}
            />
            <Alert
              variant="filled"
              severity="error"
              aria-hidden="true"
              sx={{ marginBottom: "16px" }}
            >
              Documento já Assinado, não pode ser editado!
            </Alert>
          </>
        )}
      </Box>

      <form onSubmit={handleSubmit} method="POST">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <ReactQuill
                ref={quillRef}
                value={documento.conteudo ? documento.conteudo : ""}
                onChange={handleCorpoChangeQuill}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    ["bold", "italic", "underline", "strike"],
                    ["blockquote", "code-block"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ script: "sub" }, { script: "super" }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    [{ direction: "rtl" }],
                    [{ color: [] }, { background: [] }],
                    [{ align: [] }],
                    ["link", "image", "video"],
                    ["clean"],
                    ["emoji"],
                    ["table"],
                    ["audio"],
                    [{ size: ["small", false, "large", "huge"] }],
                  ],
                }}
                placeholder="Escreva aqui . . ."
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" gap={2}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isdisabled || docAssinado}
              >
                Gravar
              </Button>

              <Button
                variant="contained"
                color="secondary"
                onClick={() => navigate(-1)}
              >
                Voltar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
